import { createAction } from 'redux-actions-helpers'
import { CriteriaItemType, MetaType, WorkType } from './types'

export const fetchRandomWork = createAction(
  '@@profile-expert-cabinet/FETCH_RANDOM_WORK'
)

export const fetchRandomWorkSuccess = createAction(
  '@@profile-expert-cabinet/FETCH_RANDOM_WORK_SUCCESS',
  (result: { data: WorkType; meta: MetaType }): any => ({ result })
)

export const fetchRandomWorkFailure = createAction(
  '@@profile-expert-cabinet/FETCH_RANDOM_WORK_FAILURE',
  (error: string): any => ({ error })
)

export const fetchCriteries = createAction(
  '@@profile-expert-cabinet/FETCH_CRITERIES',
  (contest_id: string, nomination_id: string): any => ({
    contest_id,
    nomination_id,
  })
)

export const fetchCriteriesSuccess = createAction(
  '@@profile-expert-cabinet/FETCH_CRITERIES_SUCCESS',
  (result: CriteriaItemType[]): any => ({ result })
)

export const fetchCriteriesFailure = createAction(
  '@@profile-expert-cabinet/FETCH_CRITERIES_FAILURE',
  (error: string): any => ({ error })
)

export const setCriteriaParam = createAction(
  '@@profile-expert-cabinet/SET_CRITERIA_PARAM',
  (criterion_id: string, name: string, value: string): any => ({
    criterion_id,
    name,
    value,
  })
)

export const fetchWork = createAction(
  '@@profile-expert-cabinet/FETCH_WORK',
  (userContestId: string): any => ({ userContestId })
)

export const fetchWorkSuccess = createAction(
  '@@profile-expert-cabinet/FETCH_WORK_SUCCESS',
  (result: { data: WorkType; meta: MetaType }): any => ({ result })
)

export const fetchWorkFailure = createAction(
  '@@profile-expert-cabinet/FETCH_WORK_FAILURE',
  (error: string): any => ({ error })
)

export const sendWorkReview = createAction(
  '@@profile-expert-cabinet/SEND_WORK_REVIEW',
  (
    userContestId: string,
    criteries: { criterion_id: string; point_value: number },
    isUpdateWork: boolean
  ): any => ({ userContestId, criteries, isUpdateWork })
)

export const sendWorkReviewSuccess = createAction(
  '@@profile-expert-cabinet/SEND_WORK_REVIEW_SUCCESS',
  (result: any): any => ({ result })
)

export const sendWorkReviewFailure = createAction(
  '@@profile-expert-cabinet/SEND_WORK_REVIEW_FAILURE',
  (error: string): any => ({ error })
)

export const downloadFile = createAction(
  '@@profile-expert-cabinet/SET_DOWNLOAD_PROGRESS',
  (
    file_id: string,
    url: string,
    name: string,
    onProgress: (file_id: string, percent: number) => void
  ): any => ({ file_id, url, name, onProgress })
)

export const destroy = createAction('@@profile-expert-cabinet/DESTROY')
